import { settingsController } from 'reactApp/modules/settings/settings.controller';
import { sendGa } from 'reactApp/utils/ga';

const datalist = 'new';

export const sendDatalistGa = (action = '', label = '') => {
    sendGa(`datalist-${datalist}-${settingsController.getViewMode()}`, action, label);
};
